export default __webpack_public_path__ + "static/media/Anlage_3_-_Frequenzzuteilungs-Antrag_3700-3800_MHz.8cd269bd.xlsx";